import { render, staticRenderFns } from "./OnboardingGuestStep2.vue?vue&type=template&id=10e576d6&scoped=true"
import script from "./OnboardingGuestStep2.vue?vue&type=script&lang=js"
export * from "./OnboardingGuestStep2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e576d6",
  null
  
)

export default component.exports